import YouTube from './YouTube'

export default YouTube
// eslint-disable-next-line import/export
export * from './YouTube'
